import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';
import LabelText from 'components/text/LabelText';

import { TEST_ID } from './constants';
import type { ChangeEvent, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const SliderField: FunctionComponent<Props> = ({
    className = '',
    disabled = false,
    label,
    max,
    min,
    onChange,
    step,
    testId = TEST_ID,
    unit = '',
    value
}) => {
    const displayValue = unit ? `${value} ${unit}` : `${value}`;

    const labelDisabledClass = disabled ? styles.labelDisabled : '';
    const valueDisabledClass = disabled ? styles.valueDisabled : '';

    const fillPercent = max === min ? 0 : ((value - min) / (max - min)) * 100;
    const fillStyle = { ['--slider-field-value-percent' as string]: `${fillPercent}%` };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange({ value: Number(event.target.value) });
    };

    return (
        <VerticalContainer className={`${className} ${styles.sliderField}`} testId={testId}>
            <HorizontalContainer className={styles.labelRow}>
                <LabelText className={`${labelDisabledClass} ${styles.label}`} text={label} />

                <BodyText className={`${valueDisabledClass} ${styles.value}`} text={displayValue} />
            </HorizontalContainer>

            <input
                className={styles.rangeInput}
                data-testid={testId}
                disabled={disabled}
                max={max}
                min={min}
                onChange={handleChange}
                step={step}
                style={fillStyle}
                type='range'
                value={value}
            />
        </VerticalContainer>
    );
};

export default SliderField;
